
<nz-col>
    <nz-table >
        <thead class="table">
            <tr>
                
                <th [nzSortFn]="true" [nzWidth]="'16%'">TRANS</th>
                <th [nzSortFn]="true" [nzWidth]="'16%'">COUNT</th>
             
                
            </tr>
        </thead>
        <tbody >
         
            <tr>
                <td ></td>
               
             
              
            </tr>
         
       
      </tbody>
    </nz-table>

    </nz-col>